module.exports = __webpack_public_path__ + "static/media/logo-facebook.a398f919.svg";